import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NewHomepage from './pages/NewHomepage';
import LegacyHomepage from './pages/LegacyHomepage';
import VaultPlaceholder from './pages/VaultPlaceholder';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
      <Routes>
        <Route path="/" element={<LegacyHomepage />} />
        <Route path="/installation" element={<NewHomepage />} />
        <Route path="/vault" element={<VaultPlaceholder />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
